module.exports = __webpack_public_path__ + "img/chuck.938ca963.gif";